import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../../lib/AppContext";
import Divider from "@mui/material/Divider";
import {addToFavorites, getCustomerSales, printOrder} from "../../common/api/CustomerProfileApi";
import Icon from "@mui/material/Icon";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Menu from "@mui/material/Menu";
import NotificationItem from "../../Items/NotificationItem";
import ViewSaleItemModal from "../../inventory/ViewSaleItemModal";
import MDButton from "../../../components/MDButton";
import Loading from "../../common/Loading";
import Confirm from "../../common/Confirm";
import {archiveSalesItem} from "../../common/api/WebApi";
import {formatCurrency, formatDateTime} from "../../common/Utils";
import {Chip} from "@mui/material";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function CustomerSaleGroupHistory(props) {
  const [context, setContext] = useContext(AppContext);
  const customer = props.customer;
  const [salesResp, setSalesResp] = useState();
  const [viewingSale, setViewingSale] = useState(false);
  const [saleItem, setSaleItem] = useState({});
  const [savingSaleItem, setSavingSaleItem] = useState(false);

  const [salesLoading, setSalesLoading] = useState(false);

  const [viewAllSales, setViewAllSales] = useState(props?.fullSalesHistory || false);

  useEffect(() => {
    if (props?.saleHistoryIndex > 1) {
      getCustomerSalesFn(props?.customer?.guid, viewAllSales);
    }
  }, [props?.saleHistoryIndex]);

  const getCustomerSalesFn = async (guid, viewAll) => {
    setSalesLoading(true);
    let result = await getCustomerSales(guid, viewAll);
    setSalesResp(result);
    setSalesLoading(false);
  }

  useEffect(() => {
    getCustomerSalesFn(props?.customer?.guid, viewAllSales);
  }, [props?.customer?.guid]);

  const viewSale = (saleItem) => {
    props.modalActive();
    setSaleItem(saleItem);
    setViewingSale(true);
  }


  const doArchiveSale = (saleItem) => {
    setArchivingSale(true);
    archiveSalesItem(saleItem).then((resp) => {
      setArchivingSale(false);
      setConfirmation(null);
      setShowArchiveSale(false);
      props?.callback();
    });
  }

  const [confirmation, setConfirmation] = useState();
  const [showArchiveSale, setShowArchiveSale] = useState(false);
  const [archivingSale, setArchivingSale] = useState(false);

  const addToFavoritesFn = (saleItem) => {
    addToFavorites(props?.customer?.guid, saleItem).then((resp=> {
      getCustomerSalesFn(props?.customer?.guid, viewAllSales);
      props?.memberCallback();
    }))
  }

  const archiveSale = (saleItem) => {
    props.modalActive();
    setSaleItem(saleItem);
    setConfirmation({
      title: 'Archive Sale?',
      message: 'Confirm Archive ' + saleItem?.itemName,
    })
    setShowArchiveSale(true);
  }

  const saveSaleItem = async () => {
    setSavingSaleItem(false);
    setViewingSale(false);
    props.modalInactive();
    getCustomerSalesFn(props?.customer?.guid, viewAllSales);
  }


  const SaleItemActions = ({group, item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                viewSale(item)
              }} icon={<Icon>receipt</Icon>} title={"View Sale"}/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                addToFavoritesFn(item)
              }} icon={<Icon>star</Icon>} title={"Add to Favorites"}/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                archiveSale(item)
              }} icon={<Icon>delete</Icon>} title={"Archive Sale"}/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const closeSaleItemModal = () => {
    setViewingSale(false);
    props.modalInactive();
  }

  const [purchaseGroupFilter, setPurchaseGroupFilter] = useState([]);

  const toggleFilterById = (id) => {
    let _purchaseGroupFilter = [...purchaseGroupFilter];
    if (_purchaseGroupFilter.indexOf(parseInt(id, 10)) > -1) {
      _purchaseGroupFilter.splice(purchaseGroupFilter.indexOf(parseInt(id, 10)), 1);
    } else {
      _purchaseGroupFilter = [...purchaseGroupFilter, parseInt(id, 10)];
    }
    setPurchaseGroupFilter(_purchaseGroupFilter);
  }

  return (
    <>
      <div id="chart">
        <h5>
          Customer Sale History
          {!viewAllSales && <MDButton size={"small"} color="secondary" onClick={() => {
            setViewAllSales(true);
            getCustomerSalesFn(props?.customer?.guid, true);
          }} className={'pull-right'}>View All</MDButton>}
        </h5>
        <Divider/>
        <ul className={'list-group'}>
          {salesLoading && <Loading/>}
          {!salesLoading && salesResp?.salesGroups?.length === 0 && <li className={'list-group-item'}>
            <center>No recent sales</center>
          </li>
          }
          {!salesLoading && salesResp?.salesGroups?.sort((a, b) => new Date(b.purchaseDate).getTime() - new Date(a.purchaseDate).getTime()).map((group, index) => {
              return (
                <li key={index} className={'list-group-item'}>
                  {formatDateTime(group.purchaseDate)} - {formatCurrency(group.totalSales)}
                  <MDButton className={'pull-right'}
                            variant="outlined"
                            color="secondary"
                            size="small"
                            circular
                            iconOnly
                            onClick={() => {
                              toggleFilterById(group.purchaseGroupGk);
                            }}>{purchaseGroupFilter.indexOf(group.purchaseGroupGk) > -1 ? <ExpandLessIcon/> :
                    <ExpandMoreIcon/>}</MDButton>
                  {purchaseGroupFilter.indexOf(group.purchaseGroupGk) <= -1 && <>
                    <br/>

                    {group?.extPurchaseId &&
                      <>
                        <MDButton
                          variant="outlined"
                          color="secondary"
                          size="small"
                          circular
                          iconOnly
                          className={'m-chip'}
                          onClick={(e)=>{
                            printOrder(group.extPurchaseId).then((resp)=>{
                              let _context = {...context};
                              _context.toast = {
                                message: 'See Printer For Confirmation',
                              }
                              setContext({..._context});
                            })
                          }}
                        >
                          <Icon>print</Icon>
                        </MDButton>&nbsp;
                      </>
                    }

                    <Chip
                      size={'small'}
                      label={<>{group.salesItems.length} items</>}
                      variant={'outlined'}
                      className={'m-chip '}
                      color={'secondary'}/>

                    {group.totalTips > 0 && <>
                      <Chip
                        size={'small'}
                        label={<>Tip: {formatCurrency(group.totalTips)}</>}
                        variant={'outlined'}
                        className={'m-chip '}
                        color={'secondary'}/>
                    </>}

                    {context.sessionUser?.companyLinkAccess?.length > 0 && <>
                      <Chip
                        size={'small'}
                        label={<>{group?.companyName}</>}
                        className={'m-chip '}
                        color={'secondary'}/>
                    </>}

                  </>}


                  {purchaseGroupFilter.indexOf(group.purchaseGroupGk) > -1 &&
                    <div className={'psb-bordered mt-1'}>
                      <ul className={'list-group'} style={{
                        display: 'block',
                        clear: 'both'
                      }}>
                        {group.salesItems?.map((item, idx) => {
                          return (<li
                            className={'list-group-item'}
                            key={idx}>
                                    <span
                                      className={'pull-right'}>
                                     {context?.sessionUser?.companyGk === group?.companyId &&
                                       <span className="d-block pull-right px-2 cursor-pointer">
                                       <SaleItemActions group={group} item={item}/>
                                       </span>
                                     }
                                    </span>
                            {item?.itemName} {item?.quantity > 1 && <>({item.quantity})</>
                          } {item.deposit ? ' (Deposit)' : ''}
                            <br/>
                            <Chip
                              label={<>
                                {item.refunded && <>
                                  <span className={'text-decoration-line-through'}>
                                    {formatCurrency(item.chargeAmount)}
                                  </span>
                                  &nbsp;(refunded {formatCurrency(item.refundAmount)})
                                </>
                                }
                                {!item.refunded && <>
                                  {formatCurrency(item.chargeAmount)}
                                </>}
                              </>
                              }
                              variant={item.refunded ? 'filled' : 'outlined'}
                              color={item.refunded ? 'secondary' : 'primary'}/>&nbsp;
                            {item.discounts?.map((discount, idx) => {
                              return (<Chip
                                key={idx}
                                label={<>{discount.discountReason}&nbsp;({formatCurrency(discount.discountAmount)})</>}
                                variant={'filled'}
                                className={'m-chip mr-1'}
                                color={'secondary'}/>)
                            })}

                          </li>)
                        })
                        }

                      </ul>
                      <div className={'cls clear-both d-block mt-1'}>
                        {group?.chargeTypes?.map((ct, idx) => {
                          return (
                            <span key={idx}>
                          {ct?.name && <>
                            <Chip index={idx} size={'small'} className={'m-chip'} color={'secondary'} label={ct?.name}/>
                          </>}
                        </span>
                          )
                        })}

                        {group.totalTips > 0 && <>
                          <Chip
                            size={'small'}
                            label={<>Tip: {formatCurrency(group.totalTips)}</>}
                            variant={'outlined'}
                            className={'m-chip '}
                            color={'secondary'}/>
                        </>}

                      </div>
                    </div>
                  }
                </li>
              )
            }
          )}
        </ul>
      </div>

      {
        confirmation && showArchiveSale && <Confirm confirmation={confirmation}
                                                    show={showArchiveSale}
                                                    saving={archivingSale}
                                                    handleSave={() => {
                                                      setConfirmation(null);
                                                      setShowArchiveSale(false);
                                                    }}
                                                    handleConfirm={() => {
                                                      doArchiveSale(saleItem);
                                                    }}/>
      }

      {viewingSale && <ViewSaleItemModal
        saleItem={saleItem}
        show={viewingSale}
        saving={savingSaleItem}
        handleSave={saveSaleItem}
        handleClose={closeSaleItemModal}/>}

    </>
  );
}